import type {
  AmPm,
  TimeValue,
} from "../../../../lib/utils/hallowAdminDashboard/eventForm.model";

const HOURS = [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11] as const;
const MINUTES = [0, 15, 30, 45] as const;

/** Every 15-minute wall time in a day, ordered from 12:00 AM through 11:45 PM. */
export function allQuarterHourTimesInOrder(): TimeValue[] {
  const out: TimeValue[] = [];
  for (const amPm of ["AM", "PM"] as AmPm[]) {
    for (const hour of HOURS) {
      for (const minute of MINUTES) {
        out.push({ hour, minute, amPm });
      }
    }
  }
  return out;
}
